import { Identifier } from 'react-admin';

export const getId = (id: Identifier | undefined): string => {
  return id?.toString()?.split('/')?.slice(-1)[0] ?? '';
};
